<template>
    <div class="th-tooltip th-tooltip-bottom-start cursor-pointer" :data-tip="$t('similarityTip')">
        <span class="th-badge th-badge-secondary h-6" :class="levelBgColor">
            <component :is="levelIcon" class="mr-1"></component>
            {{ label }}
            {{ similarity }}
        </span>
    </div>
</template>

<script setup lang="ts">
import SimilarLow from '@/components/icons/IconSimilarLow.vue'
import SimilarHigh from '@/components/icons/IconSimilarHigh.vue'
import SimilarMiddle from '@/components/icons/IconSimilarMiddle.vue'
import { parseInt, get } from 'lodash'
import { computed } from 'vue'
const props = defineProps<{
    similarity: string,
    label: string
}>()

enum ESimilarLevel {
    LOW = 'LOW',
    HIGH = 'HIGH',
    MIDDLE = 'MIDDLE'
}

const ESimilarIcon = {
    LOW: SimilarLow,
    MIDDLE: SimilarMiddle,
    HIGH: SimilarHigh,
}

enum ESimilarColor {
    LOW = 'bg-green-40 bg-opacity-80',
    MIDDLE = 'bg-yellow-40 bg-opacity-80',
    HIGH = 'bg-red-40 bg-opacity-80'
}

/**
 * 不同相似度区分层级
 */
const level = computed(() => {
    const number = parseInt(props.similarity)
    if (number >= 90) return ESimilarLevel.HIGH
    if (number >= 60 && number < 90) return ESimilarLevel.MIDDLE
    return ESimilarLevel.LOW
})

/**
 * 图标
 */
const levelIcon = computed(() => {
    return get(ESimilarIcon, level.value)
})

/**
 * 背景色
 */
const levelBgColor = computed(() => {
    return get(ESimilarColor, level.value)
})

</script>
